<template>
	<!-- eslint-disable vue/no-v-html -->
	<div v-html="markdown" />
</template>

<script lang="ts" setup>
import {marked} from "marked";

const properties = defineProps<{
	content: string;
}>();

const markdown = computed(() => marked.parse(properties.content));
</script>
